import { render, staticRenderFns } from "./LayoutSearchNavigation.vue?vue&type=template&id=10edfa03&"
import script from "./LayoutSearchNavigation.vue?vue&type=script&lang=js&"
export * from "./LayoutSearchNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10edfa03')) {
      api.createRecord('10edfa03', component.options)
    } else {
      api.reload('10edfa03', component.options)
    }
    module.hot.accept("./LayoutSearchNavigation.vue?vue&type=template&id=10edfa03&", function () {
      api.rerender('10edfa03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/layout/LayoutSearchNavigation.vue"
export default component.exports